export default {
    title: "Knowledge Base",
    subtitle: "Gestisci knowledge base e documenti per l'agente AI",
    newKnowledgeBase: "Nuova Knowledge Base",
    searchPlaceholder: "Cerca per nome o descrizione...",
    typePlaceholder: "Filtra per tipo",
    headers: {
        name: "Nome",
        description: "Descrizione",
        type: "Tipo",
        documentCount: "Documenti",
        createdAt: "Data Creazione",
        actions: "Azioni",
    },
    types: {
        general: "Generale",
        documents: "Documenti",
        routes: "Rotte",
        regulation: "Regolamentazione",
        "company/account-specific": "Specifico Azienda/Account",
        companyAccountSpecific: "Specifico Azienda/Account",
    },
    actions: {
        view: "Visualizza",
        edit: "Modifica",
        delete: "Elimina",
        viewDocuments: "Visualizza Documenti",
    },
    form: {
        new: "Nuova Knowledge Base",
        edit: "Modifica Knowledge Base",
        fields: {
            name: "Nome",
            namePlaceholder: "Inserisci nome knowledge base",
            description: "Descrizione",
            descriptionPlaceholder: "Inserisci descrizione (opzionale)",
            type: "Tipo",
            typePlaceholder: "Seleziona tipo",
        },
        documents: {
            title: "Documenti",
            uploadArea: "Trascina file qui o clicca per selezionare",
            supportedFormats: "Formati supportati: PDF, DOCX, TXT, MD, JSON",
            selectFile: "Seleziona File",
            selectedFiles: "File selezionati:",
            noDocuments: "Nessun documento allegato",
            remove: "Rimuovi",
            upload: "Carica",
        },
        save: "Salva",
        cancel: "Annulla",
        create: "Crea",
    },
    modal: {
        confirmDelete: "Conferma Eliminazione",
        confirmDeleteMessage: "Sei sicuro di voler eliminare questa knowledge base? Questa azione non può essere annullata.",
        cancel: "Annulla",
        delete: "Elimina",
    },
    loading: "Caricamento...",
    noData: {
        title: "Nessuna knowledge base disponibile",
        message: "Non ci sono knowledge base da visualizzare",
        createFirst: "Crea la prima knowledge base",
    },
    detail: {
        title: "Dettagli Knowledge Base",
        backToList: "Torna alla Lista",
        documents: "Documenti",
        noDocuments: "Nessun documento in questa knowledge base",
        uploadDocument: "Carica Documento",
    },
    documentDetail: {
        tabs: {
            metadata: "Metadati",
            content: "Contenuto",
            chunks: "Chunks",
        },
        fields: {
            title: "Titolo",
            source: "Origine",
            category: "Categoria",
            topic: "Argomento",
            tags: "Tag",
            priority: "Priorita'",
            accessLevel: "Livello Accesso",
            language: "Lingua",
            version: "Versione",
            retrievalCount: "Recuperi",
            chunkCount: "Chunks",
            embeddingQuality: "Qualita' Embedding",
            createdAt: "Creato",
            updatedAt: "Aggiornato",
            lastRetrieved: "Ultimo Recupero",
        },
        content: {
            characters: "caratteri",
            words: "parole",
            empty: "Nessun contenuto disponibile",
        },
        chunks: {
            noChunks: "Nessun chunk disponibile",
        },
        actions: {
            edit: "Modifica",
            delete: "Elimina",
            confirmDelete: "Conferma Eliminazione",
            regenerate: "Ri-genera Embeddings",
        },
        messages: {
            updateSuccess: "Documento aggiornato con successo",
            updateError: "Errore nell'aggiornamento del documento",
            deleteConfirm: "Sei sicuro di voler eliminare questo documento? L'azione non puo' essere annullata.",
            regenerateSuccess: "Embeddings rigenerati con successo",
            regenerateError: "Errore nella rigenerazione degli embeddings",
        },
    },
};
